module.exports = __webpack_public_path__ + "static/media/american.86948864.png";